
export class MonitoringResult {
    constructor(
        readonly xAxis: string,
        readonly yAxis: number
    ) { }
}

export class MonitoringSearch {
    constructor(
        readonly key: SearchKeyType,
        readonly dgeId: number
    ) { }
}

export enum SearchKeyType {
    Cpu = 'cpu',
    Ram = 'ram',
    Java = 'java',
    Disk = 'disk'
}
